import { render, staticRenderFns } from "./FormTable.vue?vue&type=template&id=7c553f4a&scoped=true"
import script from "./FormTable.vue?vue&type=script&lang=js"
export * from "./FormTable.vue?vue&type=script&lang=js"
import style0 from "./FormTable.vue?vue&type=style&index=0&id=7c553f4a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c553f4a",
  null
  
)

export default component.exports